export default class ConfigurationEmailUtilsService {
	constructor() {
		// this.configurationSmtp = {
		// 	idSociete: null,
		// 	smtpLogin: null,
		// 	smtpPass: null,
		// 	smtpServer: null,
		// 	smtpPort: null,
		// 	smtpAlias: null,
		// 	smtpIsSslConnection: null,
		// 	smtpIsTlsConnection: null,
		// 	isConfigurationPortail: null
		// };
	}

	// Fonction de validation
	isSmtpConfigValide(config) {
		// vérifier que le port est un entier valide
		if (isNaN(Number(config.smtpPort)) || Number(config.smtpPort) <= 0) {
			return false;
		}
		const requiredFields = ['smtpServer', 'smtpLogin', 'smtpPass'];
		for (const field of requiredFields) {
			const value = config[field];
			if (!value || typeof value !== 'string' || value.trim() === '') {
				return false;
			}
		}

		return true;
	}

	isValidEmail(email) {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	}
}
